import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

import { Tooltip, Popover, Select, Input, Row, Button } from "ant-design-vue"
import { computed, ref, onMounted, reactive, nextTick } from "vue"
import { cloneDeep } from 'lodash-es';
import { useTableContext } from '../../hooks/useTableContext'
import type { TableColumn } from '../../types/column';
import { formatAutoCols } from "../../hooks/editable-cols"
import { isObject } from "../../../../../utils/is";
import { type cloumnFilterItem } from "../../dynamic-table"
import { i18n } from "../../../../../locales/index"
import type { optionItem } from "../../types/table"


type TableColumnType<T = any> = TableColumn<T> & {
  /** 目的是解决：类型实例化过深，且可能无限 */
  formItemProps?: any;
};
type fieldOptionType = {
  label: string,
  value: string
}
//查询参数的匹配方式

export default /*@__PURE__*/_defineComponent({
  __name: 'filter-query-form',
  emits: ["complex-query"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const compareType = [
  {
    label: "模糊查询",
    value: "Like"
  },
  {
    label: "相等",
    value: "Equal"
  },
  {
    label: "In",
    value: "In"
  },
  {
    label: "小于",
    value: "LessThan"
  },
  {
    label: "不小于",
    value: "NotLessThan"
  },
  {
    label: "大于",
    value: "MoreThan"
  },
  {
    label: "不大于",
    value: "NotMoreThan"
  },
  {
    label: "NotIn",
    value: "NotIn"
  },
  {
    label: "介于之间",
    value: "BetWeen"
  },
  {
    label: "介于之间",
    value: "BetWeen"
  },
  {
    label: "不等于",
    value: "NotEqual"
  },

]

const dynamicValidateForm = reactive<{ domains: optionItem[] }>({
  domains: [],
});

const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 24, offset: 0 },
    sm: { span: 20, offset: 4 },
  },
};
const table = useTableContext();
const defaultColumns = cloneDeep<TableColumnType[]>(table.columns.length > 0 ? table.columns : formatAutoCols(table, emit));

const visible = ref<boolean>(false);
const currentSelect = ref<string>("");

const ColOption = computed(() => {
  let tempArray = [] as fieldOptionType[]
  for (let i = 0; i < defaultColumns.length; i++) {
    let temp = {
      label: defaultColumns[i].title,
      value: defaultColumns[i].dataIndex
    }
    let copy = {} as fieldOptionType
    Object.assign(copy, temp);
    tempArray.push(copy)
  }
  return tempArray
})

const isNull = function (value) {
  if (value === "" || value === null || typeof value == "undefined") {
    return true
  } else {
    return false
  }

}

const showColor = computed(() => {
  if (dynamicValidateForm.domains.length > 0) {
    let bRet = false
    for (let i = 0; i < dynamicValidateForm.domains.length; i++) {
      if (!isNull(dynamicValidateForm.domains[i].Value)) {
        bRet = true
      }
    }
    if (bRet == true) {
      //说明查询条件不为空
      return {
        color: 'dodgerblue'
      }
    } else {
      return { color: '#555555' }
    }

  } return {
    color: '#555555'
  }
})

const removeDomain = function (domain) {
  //移除相关选项
  let index = $.inArray(domain, dynamicValidateForm.domains)
  if (index == -1) {
    //如果为-1的话，表示没有找到
    return
  }
  dynamicValidateForm.domains.splice(index, 1)
}

const handleChooseChange = function (value) {
 // console.log(value)
  let temp = {} as optionItem
  temp.Key = value
  temp.MatchCase = "Like"
  temp.Value = ""
  temp.IsNull = false
  dynamicValidateForm.domains.push(temp)
  currentSelect.value = "" //查询条件生成之后，需要清空选项
}
const initQueryData = function () {
  //将模糊查询数据初始化出来，作为基础数据查询
  dynamicValidateForm.domains = []
  for (let i = 0; i < table.columnFilter.length; i++) {
    let temp = {} as optionItem
    if (typeof table.columnFilter[i] == "string") {
      temp = {
        Value: "",
        Key: table.columnFilter[i] as string,
        MatchCase: "Like",
        IsNull: false
      }
      let copy = {} as optionItem
      Object.assign(copy, temp)
      dynamicValidateForm.domains.push(copy)
    } else if (isObject(table.columnFilter[i])) {
      temp = {
        Value: "",
        Key: (table.columnFilter[i] as cloumnFilterItem).prop as string,
        MatchCase: ((table.columnFilter[i] as cloumnFilterItem).type as string).toLowerCase() != "checkbox" || ((table.columnFilter[i] as cloumnFilterItem).type as string).toLowerCase() != "combox" ? "Equal" : "Like",
        IsNull: false
      }
      let copy = {} as optionItem
      Object.assign(copy, temp)
      dynamicValidateForm.domains.push(copy)
    }
  }
}

//检查是否下拉框
const _isCombox = function (prop) {
  for (var i in table.columnFilter) {
    var filter = table.columnFilter[i];
    if (typeof filter == 'object') {
      if (filter.prop && filter.prop == prop)
        if (filter.type && filter.type.toLocaleLowerCase() == "combox" && typeof filter.options != 'undefined') return true;
    }
  }
  return false;
}
const _isCheckbox = function (prop) {
  for (var i in table.columnFilter) {
    var filter = table.columnFilter[i];
    if (typeof filter == 'object') {
      if (filter.prop && filter.prop == prop)
        if (filter.type && filter.type.toLocaleLowerCase() == "checkbox") return true;
    }
  }
  return false;
}
const getOption = function (field) {
  for (let i in table.columnFilter) {
    var filter = table.columnFilter[i];
    if (typeof filter == 'object') {
      if (filter.prop == field) {
        return filter.options
      }
    }
  }
  return []
}

const getCheckOption = function () {
  const { t } = i18n.global
  return [
    {
      value: null,
      label: t("component.table.allLabel"),
    },
    {
      value: true,
      label: t("component.table.YesLabel"),
    },
    {
      value: false,
      label: t("component.table.NoLabel"),
    },
  ]
}

const handleConfirm = function () {
  visible.value = false
  emit("complex-query", dynamicValidateForm.domains);
}

const handleReset = function () {
  initQueryData() //重置查询条件
  nextTick(() => {
    emit("complex-query", dynamicValidateForm.domains);
  })

}

const handleCancel = function () {
  visible.value = false
}

onMounted(() => {
  initQueryData()
})



return (_ctx: any,_cache: any) => {
  const _component_MinusCircleOutlined = _resolveComponent("MinusCircleOutlined")!

  return (_openBlock(), _createBlock(_unref(Tooltip), { placement: "top" }, {
    title: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('component.table.batchQueryItem')), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Popover), {
        placement: "bottomLeft",
        trigger: "click",
        open: visible.value,
        "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event))
      }, {
        content: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dynamicValidateForm.domains, (domain) => {
            return (_openBlock(), _createBlock(_unref(Row), _mergeProps({
              key: domain.Key,
              ref_for: true,
              ref: "formRef",
              name: "dynamic_form_item",
              model: dynamicValidateForm
            }, { ref_for: true }, formItemLayoutWithOutLabel, {
              layout: "vertical",
              style: {"padding":"5px"}
            }), {
              default: _withCtx(() => [
                _createVNode(_unref(Select), {
                  allowClear: "",
                  size: "small",
                  style: {"width":"100px"},
                  value: domain.Key,
                  "onUpdate:value": ($event: any) => ((domain.Key) = $event),
                  placeholder: "",
                  options: ColOption.value
                }, null, 8, ["value", "onUpdate:value", "options"]),
                _createVNode(_unref(Select), {
                  allowClear: "",
                  size: "small",
                  style: {"width":"100px","margin-left":"1px"},
                  value: domain.MatchCase,
                  "onUpdate:value": ($event: any) => ((domain.MatchCase) = $event),
                  placeholder: "",
                  options: compareType
                }, null, 8, ["value", "onUpdate:value"]),
                (_isCombox(domain.Key))
                  ? (_openBlock(), _createBlock(_unref(Select), {
                      key: 0,
                      allowClear: "",
                      size: "small",
                      style: {"width":"100px","margin-left":"1px"},
                      value: domain.Value,
                      "onUpdate:value": ($event: any) => ((domain.Value) = $event),
                      placeholder: "",
                      options: getOption(domain.Key)
                    }, null, 8, ["value", "onUpdate:value", "options"]))
                  : (_isCheckbox(domain.Key))
                    ? (_openBlock(), _createBlock(_unref(Select), {
                        key: 1,
                        allowClear: "",
                        size: "small",
                        style: {"width":"100px","margin-left":"1px"},
                        value: domain.Value,
                        "onUpdate:value": ($event: any) => ((domain.Value) = $event),
                        placeholder: "",
                        options: getCheckOption()
                      }, null, 8, ["value", "onUpdate:value", "options"]))
                    : (_openBlock(), _createBlock(_unref(Input), {
                        key: 2,
                        style: {"width":"100px","margin-left":"1px"},
                        value: domain.Value,
                        "onUpdate:value": ($event: any) => ((domain.Value) = $event),
                        size: "small"
                      }, null, 8, ["value", "onUpdate:value"])),
                (dynamicValidateForm.domains.length > 1)
                  ? (_openBlock(), _createBlock(_component_MinusCircleOutlined, {
                      key: 3,
                      style: {"margin-top":"3px","margin-left":"1px"},
                      class: "dynamic-delete-button",
                      disabled: dynamicValidateForm.domains.length === 1,
                      onClick: ($event: any) => (removeDomain(domain))
                    }, null, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1040, ["model"]))
          }), 128)),
          _createVNode(_unref(Row), { style: {"padding":"5px"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(Select), {
                style: {"width":"100%"},
                allowClear: "",
                size: "small",
                value: currentSelect.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((currentSelect).value = $event)),
                placeholder: _ctx.$t('component.table.selectColInfo'),
                onChange: handleChooseChange,
                options: ColOption.value
              }, null, 8, ["value", "placeholder", "options"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Row), { style: {"padding":"5px","text-align":"right"} }, {
            default: _withCtx(() => [
              _createVNode(_unref(Button), {
                size: "small",
                onClick: handleConfirm,
                style: {"float":"right"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('component.table.confirm')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                size: "small",
                onClick: handleReset,
                style: {"float":"right"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.resetText')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                size: "small",
                onClick: handleCancel,
                style: {"float":"right"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('component.table.cancel')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("i", {
            class: "icon icon-search",
            style: _normalizeStyle(showColor.value)
          }, null, 4)
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }))
}
}

})